import React from 'react'
import { Form } from 'antd'

import { manageToast } from '../../../components/Common/ManageToast'
import { serverlessApi } from '../../../utils/API'

import InternalKeyModal from './Modal'

function LockBoxUpdateModal (props) {
  const { internalKey, onClose, open, triggerCollectionRefetch } = props

  const [form] = Form.useForm()

  const [loading, setLoading] = React.useState(false)
  const [selectedProperty, setSelectedProperty] = React.useState(undefined)

  const initialValues = React.useMemo(() => {
    if (!internalKey) {
      return {}
    }

    return {
      propertyId: internalKey?.property
        ? Number(internalKey.PropertyID)
        : undefined,
      internalKeyName: internalKey.InternalKeyName,
      unitId: internalKey?.UnitID ? Number(internalKey.UnitID) : undefined,
      internalKeyType: internalKey.InternalKeyType,
      keyType: internalKey?.property ? 'keysProperty' : 'otherKeys',
      city: !internalKey?.property ? internalKey?.city : undefined,
      boxType: internalKey.BoxType
    }
  }, [internalKey])

  const handleClose = () => {
    form.resetFields()
    setSelectedProperty(undefined)
    onClose()
  }

  const handleInternalKeyUpdate = values => {
    return Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        const {
          keyType,
          city,
          propertyId,
          unitId,
          ...restFields
        } = values

        const payload = { ...restFields }

        if (keyType === 'keysProperty') {
          payload.propertyId = propertyId
          payload.unitId = unitId
        } else {
          payload.city = city
        }

        return serverlessApi.updateInternalKey(internalKey._id, payload).then(res => {
          triggerCollectionRefetch()
          setLoading(false)
          manageToast(true, res.data.message)
          handleClose()
        })
      })
      .catch(() => setLoading(false))
  }

  return (
    <InternalKeyModal
      form={form}
      formName="internal-key-update"
      handleClose={handleClose}
      handleSubmit={handleInternalKeyUpdate}
      editForm
      initialValues={initialValues}
      loading={loading}
      internalKey={internalKey}
      open={open}
      selectedProperty={selectedProperty}
      setSelectedProperty={setSelectedProperty}
      submitButtonLabel="Update"
      title="Update internal key"
    />
  )
}

export default React.memo(LockBoxUpdateModal)
